import { render, staticRenderFns } from "./WaffleChart.vue?vue&type=template&id=150e6d81&"
import script from "./WaffleChart.vue?vue&type=script&lang=js&"
export * from "./WaffleChart.vue?vue&type=script&lang=js&"
import style0 from "./WaffleChart.vue?vue&type=style&index=0&id=150e6d81&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports